import React from "react";
import { Flex } from "antd";
import { AppParagraph } from "@/shared/Components";
import { NoContactsPageIcon, NoContactsPageIconDark } from "@/shared/icons";
import { useTheme } from "@/services/theme/lib";
import { ImportVcfNoContacts, VcfInfoButton } from "@/entities/no-contacts";
import { AddContactButton } from "@/entities/add-contact-button";
import styles from "./styles.module.scss";

interface Props {
  message: string;
  isAddContact?: boolean;
  isImportEnabled?: boolean;
}

export const NoContactsContent: React.FC<Props> = ({ message, isImportEnabled }) => {
  const { theme } = useTheme();

  return (
    <div className={styles.container}>
      {theme === "light" ? <NoContactsPageIcon /> : <NoContactsPageIconDark />}
      <AppParagraph size="lg" lineHeight="xl" weight="semibold" className={styles.message}>
        {message}
      </AppParagraph>
      <Flex gap={5}>
        {isImportEnabled && <ImportVcfNoContacts />}
        <AddContactButton />
      </Flex>
      {isImportEnabled && <VcfInfoButton />}
    </div>
  );
};
